export const COUNTRY = "COUNTRY"
export const LOGIN ="LOGIN"
export const LOGOUT ="LOGOUT"
